import { Fragment } from 'react';
import { Input, InputGroup, FormFeedback } from 'reactstrap';
import { Field, ErrorMessage } from 'formik';

export function InputFormFiled({ title, name, type, options, orgOption = false, invalid, placeholder = null, disabled = false, rows = 3, maxLength = 200 }) {
  return (
    <Fragment>
      <p
        style={{
          fontSize: '12px',
          color: '#323232',
          fontWeight: 'bold',
          marginTop: '20px',
          marginBottom: '6px',
          fontFamily: 'Noto Sans, sans-serif',
        }}
      >
        {title}
      </p>
      <InputGroup className="mb-2">
        {type === 'select' ? (
          <Field
            as="select"
            name={name}
            id={name}
            disabled={disabled}
            className={`form-control ${invalid ? 'is-invalid' : ''} custom-select`}
            style={{ fontSize: '13px' }}
          >
            <option value="" disabled></option>
            {orgOption && <option value="null">無上層組織</option>}

            {options.map((option, index) => (
              <option key={index} value={option.uuid}>
                {option.name}
              </option>
            ))}
          </Field>
        ) : type === 'textarea' ? (
          <Field name={name} id={name}>
            {({ field }) => (
              <Input
                {...field}
                type="textarea"
                placeholder={placeholder}
                disabled={disabled}
                invalid={invalid}
                rows={rows}
                maxLength={maxLength}
                style={{ fontSize: '13px', outline: 'none', boxShadow: 'none' }}
              />
            )}
          </Field>
        ) : (
          <Field name={name} id={name} type={type}>
            {({ field }) => (
              <Input
                {...field}
                id={name}
                type={type}
                placeholder={placeholder}
                invalid={invalid}
                style={{ fontSize: '13px', outline: 'none', boxShadow: 'none' }}
                disabled={disabled}
              />
            )}
          </Field>
        )}
        <ErrorMessage name={name} style={{ fontSize: '13px' }}>
          {(msg) => <FormFeedback>{msg}</FormFeedback>}
        </ErrorMessage>
      </InputGroup>
    </Fragment>
  );
}
